
export class LocalStorageService {
    static setUserId(userId) {
        localStorage.setItem("userID", userId);
    }

    static getUserId() {
        const userID = localStorage.getItem("userID");
        return userID;
    }

    static setIsAuthenticated(isLogin) {
        localStorage.setItem("isAuthenticated", isLogin);
    }

    static getIsAuthenticated() {
       const isAuth = localStorage.getItem("isAuthenticated");
       return isAuth;
    }

    static setEmail(userEmail) {
        localStorage.setItem("email", userEmail);
    }

    static getEmail() {
        const email = localStorage.getItem("email");
        return email;
    }

    static setDesignerName(dName) {
        localStorage.setItem("dname", dName);
    }

    static getDesignerName() {
        const dname = localStorage.getItem("dname");
        return dname;
    }

    static setRole(role) {
        localStorage.setItem("role", role);
    }

    static getRole() {
        const role = localStorage.getItem("role");
        return role;
    }
}